import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { PostChangeDeviceNamePayload, PostChangeDeviceNameResponse } from '@/api/device/types';
import { refreshCachedDevice } from '@/api/devices';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { SUBSCRIPTION_TAGS_INFO_QUERY_KEY } from '@/config';
import { useErrorContext } from '@/context/ErrorContext';

export const postChangeDeviceName = (payload: PostChangeDeviceNamePayload): Promise<PostChangeDeviceNameResponse> => {
    return axios.post('/device/change-name', payload);
};

type UsePostChangeDeviceNameOptions = {
    config?: MutationConfig<typeof postChangeDeviceName>;
    data?: PostChangeDeviceNamePayload;
};

export const usePostChangeDeviceName = ({ config }: UsePostChangeDeviceNameOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postChangeDeviceName,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            queryClient.invalidateQueries({ queryKey: ['device-id-list'] });
            queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_TAGS_INFO_QUERY_KEY] });
            mixpanel?.track('Device name changed', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('change device name'),
    });
};
